import { createAction, props } from '@ngrx/store';

import { CreateTrackParams } from '@services/tracks.service';
import {
  LastReportsPageStateWithTabs,
  ReportTemplateItem,
  ReportTemplatesList,
} from '@store/reports/reports.state';

export const loadReportTemplatesList = createAction('[stateReports] Load Report Templates List');

export const loadReportTemplatesListSuccess = createAction(
  '[stateReports] Load Report Templates List Success',
  props<{
    list: ReportTemplatesList;
  }>(),
);

export const loadReportTemplatesListFailure = createAction(
  '[stateReports] Load Report Templates List Failure',
  props<{
    error: string;
  }>(),
);

export const addReportTemplateItem = createAction(
  '[stateReports] Add Report Template Item',
  props<{
    item: ReportTemplateItem;
  }>(),
);
export const updateReportTemplateItem = createAction(
  '[stateReports] Update Report Template Item',
  props<{
    id: number;
    changes: Partial<any>;
  }>(),
);
export const deleteReportTemplateItem = createAction(
  '[stateReports] Delete Report Template Item',
  props<{
    id: number;
  }>(),
);

export const setLastPageStateReports = createAction(
  '[stateReports] Set last page state',
  props<{
    newPageState: Partial<LastReportsPageStateWithTabs>;
  }>(),
);

export const setParamsCreateTrackForReports = createAction(
  '[stateReports] Set params create reports track',
  props<{
    params: CreateTrackParams;
    cacheKey: string;
  }>(),
);

export const deleteTracksFromReportsPage = createAction(
  '[stateReports] Delete track from reports page',
);
